if (!customElements.get('tbhnp-measurement-chart')) {
  customElements.define('tbhnp-measurement-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      const description = JSON.parse(this.querySelector('[data-chart-description]').textContent);
      const doc = new DOMParser().parseFromString(description || '', 'text/html');
      const tables = Array.from(doc.querySelectorAll('table'));
      const table = tables.find(item => /(?:waist|chest|shoulder|hips?|length|腰|胸|肩|衣长|衣長|裤长|褲長|ウエスト|ヒップ|着丈|パンツ丈)/i.test(item.textContent) && /(?:XS|S|M|L|XL|XXL|size|尺码|尺碼)/i.test(item.textContent));
      if (table) {
        this.rows = Array.from(table.rows).map(row => Array.from(row.cells).map(cell => cell.textContent.trim()));
        let previous = table.previousElementSibling;
        while (previous && !previous.textContent.trim()) previous = previous.previousElementSibling;
        this.sourceUnit = /\bin(?:ch(?:es)?)?\b/i.test(table.caption?.textContent || previous?.textContent || '') ? 'in' : 'cm';
        const model = Array.from(doc.querySelectorAll('p, li')).find(item => /(?:model|模特|モデル)/i.test(item.textContent) && /\d/.test(item.textContent) && /(?:wear|穿|着用)/i.test(item.textContent));
        if (model) this.showModel(model.textContent.trim());
      } else {
        const raw = JSON.parse(this.querySelector('[data-chart-fallback]').textContent);
        if (!raw) return;
        const data = JSON.parse(raw);
        if (!data.sizes?.length || !data.measurements?.length) return;
        this.rows = [['', ...data.sizes], ...data.measurements.map(field => [field.label, ...data.sizes.map(size => data.chart[size]?.[field.key] || '—')])];
        this.sourceUnit = 'cm';
      }
      if (!this.rows?.length) return;
      this.lifecycle = new AbortController();
      this.querySelectorAll('[data-chart-unit]').forEach(button => button.addEventListener('click', () => this.renderTable(button.dataset.chartUnit), { signal: this.lifecycle.signal }));
      this.renderTable('cm');
      this.hidden = false;
    }
    showModel(text) {
      const node = this.querySelector('[data-chart-model]');
      node.textContent = text;
      node.hidden = false;
    }
    renderTable(unit) {
      const table = document.createElement('table');
      this.rows.forEach((cells, rowIndex) => {
        const row = table.insertRow();
        cells.forEach((value, columnIndex) => {
          const cell = document.createElement(rowIndex === 0 || columnIndex === 0 ? 'th' : 'td');
          if (cell.tagName === 'TH') cell.scope = rowIndex === 0 ? 'col' : 'row';
          const numeric = rowIndex > 0 && columnIndex > 0 && /^\d+(?:\.\d+)?$/.test(value);
          const factor = unit === this.sourceUnit ? 1 : unit === 'in' ? 1 / 2.54 : 2.54;
          cell.textContent = numeric && factor !== 1 ? String(Math.round(Number(value) * factor * 10) / 10) : value;
          row.append(cell);
        });
      });
      this.querySelector('[data-chart-table]').replaceChildren(table);
      this.querySelectorAll('[data-chart-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.chartUnit === unit)));
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = null;
    }
  });
}
